import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

const FaqPage = () => (
  <Layout>
    <SEO title="Frequently asked questions" />
    <h1>Veel gestelde vragen</h1>
    <Accordion defaultActiveKey="0">
  <Card>
    <Card.Header>
      <Accordion.Toggle as={Button} variant="link" eventKey="0">
       Welke maat is geschikt voor mij?
      </Accordion.Toggle>
    </Card.Header>
    <Accordion.Collapse eventKey="0">
      <Card.Body>Ik adviseer L voor mannen en M voor vrouwen/tieners en S voor kinderen.</Card.Body>
    </Accordion.Collapse>
  </Card>
  <Card>
    <Card.Header>
      <Accordion.Toggle as={Button} variant="link" eventKey="1">
        Kunnen de mondkapjes in de wasmachine?
      </Accordion.Toggle>
    </Card.Header>
    <Accordion.Collapse eventKey="1">
      <Card.Body>De mondkapjes kunnen in de wasmachine op 60 graden.</Card.Body>
    </Accordion.Collapse>
  </Card>
  <Card>
    <Card.Header>
      <Accordion.Toggle as={Button} variant="link" eventKey="2">
        Waarom wordt mijn mobiele nummer gevraagd?
      </Accordion.Toggle>
    </Card.Header>
    <Accordion.Collapse eventKey="2">
      <Card.Body>Uw 06 nummer is nodig voor het versturen van een betaalverzoek.</Card.Body>
    </Accordion.Collapse>
  </Card>
  <Card>
    <Card.Header>
      <Accordion.Toggle as={Button} variant="link" eventKey="3">
        Is het mogelijk een andere stof te kiezen dan die op de website staan?
      </Accordion.Toggle>
    </Card.Header>
    <Accordion.Collapse eventKey="3">
      <Card.Body>Op dit moment is hiet niet mogelijk uit andere stoffen te kiezen.</Card.Body>
    </Accordion.Collapse>
  </Card>
  <Card>
    <Card.Header>
      <Accordion.Toggle as={Button} variant="link" eventKey="4">
       Wat is de verwachte levertijd?
      </Accordion.Toggle>
    </Card.Header>
    <Accordion.Collapse eventKey="4">
      <Card.Body>Ik streef ernaar om binnen 24 uur te verzenden.</Card.Body>
    </Accordion.Collapse>
  </Card>
  <Card>
    <Card.Header>
      <Accordion.Toggle as={Button} variant="link" eventKey="5">
       Is het mogelijk om bestellingen te retourneren?
      </Accordion.Toggle>
    </Card.Header>
    <Accordion.Collapse eventKey="5">
      <Card.Body>Helaas is het niet mogelijk om bestellingen te retourneren omwille van hygiene.</Card.Body>
    </Accordion.Collapse>
  </Card>
</Accordion>
    <Link to="/">Terug naar de hoofdpagina</Link>
  </Layout>
)

export default FaqPage
